import { useEffect, useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  TextField,
} from "@mui/material";

import sondertagService from "../../services/sondertagService";
import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";

export default function TeacherWorkloadEditDialog({
  open,
  teacher,
  schoolyearId,
  onClose,
  onSaved,
}) {
  const [abbreviation, setAbbreviation] = useState("");
  const [teacherName, setTeacherName] = useState("");
  const [workload, setWorkload] = useState("");
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!open) return;

    setAbbreviation(teacher?.abbreviation ?? "");
    setTeacherName(teacher?.name ?? "");
    setWorkload(
      teacher?.workload != null
        ? String(Math.round(Number(teacher.workload) * 100))
        : "",
    );
    setComment(teacher?.comment ?? "");
  }, [open, teacher]);

  const handleSave = async () => {
    const data = {
      schoolyearId,
      abbreviation: abbreviation.trim().toLowerCase(),
      teacherName: teacherName.trim(),
      workload: Number(workload) / 100,
      comment: comment.trim(),
    };

    if (teacher?.abbreviation) {
      await sondertagService.updateTeacherStat(teacher.abbreviation, data);
    } else {
      await sondertagService.createTeacherStat(data);
    }

    onSaved?.();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {teacher ? "Lehrperson bearbeiten" : "Lehrperson hinzufügen"}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Kürzel"
            value={abbreviation}
            onChange={(e) => setAbbreviation(e.target.value)}
            inputProps={{
              maxLength: 10,
            }}
            required
            fullWidth
          />

          <TextField
            label="Name"
            value={teacherName}
            onChange={(e) => setTeacherName(e.target.value)}
            required
            fullWidth
          />

          <TextField
            label="Pensum (%)"
            type="number"
            value={workload}
            onChange={(e) => setWorkload(e.target.value)}
            inputProps={{
              min: 0,
              max: 100,
              step: 1,
            }}
            required
            fullWidth
          />

          <TextField
            label="Kommentar"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            multiline
            minRows={3}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel="Speichern"
        confirmDisabled={
          !abbreviation.trim() || !teacherName.trim() || workload === ""
        }
      />
    </Dialog>
  );
}
